
import React, {Component} from "react";

class SelectCircleMemberCard extends Component {

    selected() {
        let {circle_member, select_func} = this.props;
        select_func(circle_member);
    }
    render () {
        let {circle_member, color} = this.props;


        let style = {
            background: color
        }

        return (
            <div className='select_circle_member_card_container'>
                <div className='select_circle_member_card' onClick={this.selected.bind(this)} style={style}>
                    <img alt={circle_member.first_name + " " + circle_member.last_name} className='circle_member_face' src={require(`../../../../static/assets/home_play_dude_default.svg`)}></img>            
                </div>
                <div className='select_circle_member_card_name'>{circle_member.first_name + " " + circle_member.last_name}</div>
            </div>
            
        )
    }
}

export default SelectCircleMemberCard;




// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/select-circle-member/select-circle-member-card.js